import { render, staticRenderFns } from "./logic-and-reasoning-tests.vue?vue&type=template&id=2a63a7e6&scoped=true&"
import script from "./logic-and-reasoning-tests.vue?vue&type=script&lang=js&"
export * from "./logic-and-reasoning-tests.vue?vue&type=script&lang=js&"
import style0 from "./logic-and-reasoning-tests.vue?vue&type=style&index=0&id=2a63a7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63a7e6",
  null
  
)

export default component.exports